import { moduleFactory } from "@/factories/module";
import { parseRoutingPathname } from "@/modules/routing/parsePathname";
import { getPathTitle } from "@/modules/routing/getPathTitle";
import { getPathIcon } from "@/modules/routing/getPathIcon";

export const routingModule = moduleFactory.create({
  parsePathname: parseRoutingPathname,
  getPathTitle,
  getPathIcon,
});
